import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useLocalization } from "@/providers/useLocalization";
import { useTranslations } from "@/providers/TranslationsProvider";
import DatePickerInput from "@/components/datepicker/DatePickerInput";
import { latestBirthdate } from "@/lib/age";
import { Chip, Field, FieldMessage, INPUT, StepTitle } from "./fields";
import type { StepProps } from "./types";
export default function PersonalStep(t0) {
  const $ = _c(91);
  const {
    draft,
    update,
    errors
  } = t0;
  const {
    t
  } = useTranslations();
  const {
    config
  } = useLocalization();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = latestBirthdate();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const latest = t1;
  let t2;
  if ($[1] !== t) {
    t2 = t("join.personal title", "About you");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("join.personal subtitle", "Your name as it appears on your professional licence.");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <StepTitle title={t2} subtitle={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("join.first name", "First name");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !!draft.first_name;
  const t7 = !!errors.first_name;
  let t8;
  if ($[10] !== update) {
    t8 = e => update({
      first_name: e.target.value
    });
    $[10] = update;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== draft.first_name || $[13] !== t7 || $[14] !== t8) {
    t9 = <input className={INPUT} value={draft.first_name} maxLength={128} autoComplete="given-name" aria-invalid={t7} onChange={t8} />;
    $[12] = draft.first_name;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== errors.first_name || $[17] !== t5 || $[18] !== t6 || $[19] !== t9) {
    t10 = <Field label={t5} error={errors.first_name} filled={t6}>{t9}</Field>;
    $[16] = errors.first_name;
    $[17] = t5;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("join.last name", "Last name");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = !!draft.last_name;
  const t13 = !!errors.last_name;
  let t14;
  if ($[23] !== update) {
    t14 = e_0 => update({
      last_name: e_0.target.value
    });
    $[23] = update;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== draft.last_name || $[26] !== t13 || $[27] !== t14) {
    t15 = <input className={INPUT} value={draft.last_name} maxLength={128} autoComplete="family-name" aria-invalid={t13} onChange={t14} />;
    $[25] = draft.last_name;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== errors.last_name || $[30] !== t11 || $[31] !== t12 || $[32] !== t15) {
    t16 = <Field label={t11} error={errors.last_name} filled={t12}>{t15}</Field>;
    $[29] = errors.last_name;
    $[30] = t11;
    $[31] = t12;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t16) {
    t17 = <div className="grid gap-4 sm:grid-cols-2">{t10}{t16}</div>;
    $[34] = t10;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("join.gender", "Gender");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <span id="join-gender" className="text-[15px] sm:text-[17px] tracking-[-0.022em] text-[var(--foreground)]">{t18}</span>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const t20 = draft.gender === "female";
  let t21;
  if ($[41] !== update) {
    t21 = () => update({
      gender: "female"
    });
    $[41] = update;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t) {
    t22 = t("join.female", "Female");
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t20 || $[46] !== t21 || $[47] !== t22) {
    t23 = <Chip selected={t20} onClick={t21}>{t22}</Chip>;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  const t24 = draft.gender === "male";
  let t25;
  if ($[49] !== update) {
    t25 = () => update({
      gender: "male"
    });
    $[49] = update;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t) {
    t26 = t("join.male", "Male");
    $[51] = t;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t24 || $[54] !== t25 || $[55] !== t26) {
    t27 = <Chip selected={t24} onClick={t25}>{t26}</Chip>;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t23 || $[58] !== t27) {
    t28 = <div className="flex gap-2">{t23}{t27}</div>;
    $[57] = t23;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t19 || $[61] !== t28) {
    t29 = <div role="group" aria-labelledby="join-gender" className="flex flex-wrap items-center gap-x-5 gap-y-2">{t19}{t28}</div>;
    $[60] = t19;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== errors.gender) {
    t30 = <FieldMessage error={errors.gender} />;
    $[63] = errors.gender;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t29 || $[66] !== t30) {
    t31 = <div>{t29}{t30}</div>;
    $[65] = t29;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t) {
    t32 = t("join.birthdate", "Date of birth");
    $[68] = t;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t) {
    t33 = t("join.optional", "Optional");
    $[70] = t;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  const t34 = !!draft.birthdate;
  let t35;
  if ($[72] !== update) {
    t35 = birthdate => update({
      birthdate
    });
    $[72] = update;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== draft.birthdate || $[75] !== t35) {
    t36 = <DatePickerInput className={INPUT} placeholder="" value={draft.birthdate} maxDate={latest} onChange={t35} />;
    $[74] = draft.birthdate;
    $[75] = t35;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== config.dateFormat || $[78] !== errors.birthdate || $[79] !== t32 || $[80] !== t33 || $[81] !== t34 || $[82] !== t36) {
    t37 = <Field label={t32} optional={true} optionalText={t33} filled={t34} hint={config.dateFormat} error={errors.birthdate} dir="ltr">{t36}</Field>;
    $[77] = config.dateFormat;
    $[78] = errors.birthdate;
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t17 || $[85] !== t31 || $[86] !== t37) {
    t38 = <div className="space-y-5">{t17}{t31}{t37}</div>;
    $[84] = t17;
    $[85] = t31;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t38 || $[89] !== t4) {
    t39 = <section>{t4}{t38}</section>;
    $[88] = t38;
    $[89] = t4;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  return t39;
}